import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { useSize } from 'ahooks';
import { Button, Card, Space } from 'antd';
import Empty from 'components/Empty';
import { initEcharts } from 'lib/echarts';
import { useGetPermission } from 'hooks/business/useNewPermisson';
import { useEffect, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { useNavigate } from 'react-router-dom';
import { percentDisplay } from 'views/Dashboard/ImplementData/utils';
import AheadButton from '../business/AheadButton';
import { useDashboardFilter } from '../Filter/useFilter';
import DrawerLinkButton from '../Trend/AheadLinkButton';
import useDrawerContext from '../Trend/hooks/useDrawer';
import { ReactComponent } from './assets/bad.svg';

const Container = styled(Card)`
  .ant-card-body {
    display: flex;
    .legend {
      width: 25%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      justify-content: center;
      .ant-badge {
        color: #84868c;
      }
      .num {
        color: #515359;
        font-size: 16px;
        margin-left: 14px;
        font-weight: 500;
      }
    }
  }
  .ext {
    border: 1px solid rgba(240, 242, 245, 1);
    width: 150px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    gap: 8px;
    padding: 0 10px;
    .title {
      color: #515359;
    }
    .num {
      color: #232426;
      font-weight: 500;
      font-size: 20px;
    }
    > div:first-of-type {
      svg {
        width: 32px;
        height: 32px;
        color: #6195fa;
      }
    }
  }
`;
const Relative = styled.div`
  position: relative;
  width: 75%;
  .ant-empty {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .chatEl {
    height: 100%;
    width: 100%;
  }
`;
interface Props {
  value?: Dashboard.ReviewInner;
}
const Recover = (props: Props) => {
  const { value } = props;
  const { t } = useTranslate();
  const chartDomRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<echarts.ECharts>();
  const nav = useNavigate();
  const getPermission = useGetPermission();
  const filterCtx = useDashboardFilter();
  const { width } = useSize(chartDomRef) || {};
  const { setTrendValue } = useDrawerContext();
  useEffect(() => {
    chartRef.current?.resize();
  }, [width]);
  useEffect(() => {
    if (!value || !chartDomRef.current) {
      return;
    }
    if (!chartRef.current) {
      chartRef.current = initEcharts(chartDomRef.current);
    }
    chartRef.current.setOption({
      // width: '350px',
      legend: {
        data: [t('ViewDashboard.发起中差评挽回数'), t('ViewDashboard.成功挽回中差评数')],
      },
      series: [
        {
          type: 'funnel',
          sort: 'none',
          minSize: '50%',
          label: {
            show: true,
            position: 'inside',
            formatter: '{c}',
          },

          data: [
            {
              value: value?.发起中差评挽回数,
              name: t('ViewDashboard.发起中差评挽回数'),
              itemStyle: {
                color: '#5B8FF9',
                opacity: 0.85,
              },
            },
            {
              value: value?.成功挽回中差评数,
              name: t('ViewDashboard.成功挽回中差评数'),
              itemStyle: {
                color: '#5AD8A6',
                opacity: 0.85,
              },
            },
          ],
        },
      ],
    });
  }, [value, t]);
  const showEmpty = !value?.发起中差评挽回数 && !value?.成功挽回中差评数;
  return (
    <Container
      title={
        <div className="flex gap-2 items-center justify-between flex-wrap">
          <div>
            <span className="before" />
            {t('ViewDashboard.中差评挽回')}
          </div>
          <Space wrap>
            <DrawerLinkButton performanceName="FIX_COMMENT_REMINDER_CONVERSION_RATE" />
            {getPermission('配置评价管理任务') && (
              <Button
                type="link"
                onClick={() =>
                  nav(`/aide/review/review/NEGATIVE_REVIEW_SAVE?platform=${filterCtx.platform}`)
                }
              >
                {t('ViewDashboard.中差评挽回配置')}
              </Button>
            )}
          </Space>
        </div>
      }
    >
      <Relative>
        <div
          ref={chartDomRef}
          className="chatEl"
          style={{ display: showEmpty ? 'none' : 'block' }}
        />
        {showEmpty ? <Empty>{t('ViewDashboard.如未配置中差评挽回，请先进行配置')}</Empty> : null}
      </Relative>
      <div className="ext">
        <div>
          <Icon component={ReactComponent} />
        </div>
        <div className="title">{t('ViewDashboard.中差评挽回率')}</div>
        <div className="num">{percentDisplay(value?.中差评挽回率)}</div>
        <AheadButton
          rate={value?.中差评挽回领先率 ?? 0}
          onClick={() => {
            setTrendValue({
              type: 'rank',
              params: { performanceName: 'FIX_COMMENT_REMINDER_CONVERSION_RATE' },
              visible: true,
            });
          }}
        />
      </div>
    </Container>
  );
};
export default Recover;
